import React,{useState} from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import BaseUrl from '../Components/BaseUrl';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const Onboardingstep1 = () => {
    const navigate =useNavigate();
    const [formData, setFormData] = useState({
      fname: "",
      lname:"",
    });
    const [error, setError] = useState({
        fname: "",
        lname:"",
    })

    const handleChange = (e) => {
        const {id,value}=e.target;
        setFormData({...formData,[id]:value})
        setError({...error,[id]:""})
    }
    const validateForm=()=>{
        let isValid=true;
        let errors={};
        if (formData.fname.trim() === "") {
            errors.fname = "first name is required";
            isValid = false;
        }
        if (formData.lname.trim() === "") {
            errors.lname = "last name is required";
            isValid = false;
        }
        setError(errors);
        return isValid;
    }
    const handleSubmit=async(e)=>{
        e.preventDefault();
        const result=validateForm();
        if(result){
            window.localStorage.setItem("fname", formData.fname);
            window.localStorage.setItem("lname", formData.lname);
            navigate("/user/onboarding/step2")
        }
    }
    
  return (
    <>
      <div className="flex flex-col items-center justify-start  min-h-screen bg-[#F3F2EF] mt-14 py-10 px-4 sm:px-6 lg:px-8">
        <div className="mt-6"><p className="text-3xl font-normal mb-4">  Make the most of your professional life</p></div>
        <div className="w-full max-w-md">
        
          <form className="bg-white p-8 rounded-lg shadow-xl ">
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-1"
                htmlFor="name"
              >
                First Name <span className="text-red-500">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="fname"
                value={formData.fname}
                onChange={handleChange}
                type="text"
                placeholder="First Name"
              />
              <span className="text-red-500 ml-1 text-sm mb-1">{error.fname}</span>
            </div>

            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-1"
                htmlFor="name"
              >
                Last Name <span className="text-red-500">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="lname"
                value={formData.lname}
                onChange={handleChange}
                type="text"
                placeholder="Last Name"
              />
              <span className="text-red-500 ml-1 text-sm mb-1">{error.lname}</span>
            </div>
            
            <div className=" mt-8 flex flex-col items-center">
              <button
                className="bg-[#0A66C2] hover:bg-blue-700 text-white text-LG font-bold py-2 px-4 h-12 rounded-full w-full"
                type="button"
                onClick={handleSubmit}
              >
                Continue
              </button>
            </div>
            
            
            
          </form>
        </div>
      </div>
    </>
  );
};

export default Onboardingstep1;
